/* Beanwatch – Kombi-CTA: legt zwei Produkte gleichzeitig in den Warenkorb.
   Bildet den Ablauf aus component-product-form.js nach, damit sich der Button
   verhält wie jeder andere Kaufbutton im Shop. */
(function(){
  var buttons = document.querySelectorAll('[data-bw-combo]');
  if (!buttons.length) return;

  buttons.forEach(function(btn){
    if (btn.getAttribute('data-bw-bound')) return;
    btn.setAttribute('data-bw-bound','1');

    var errorEl = btn.parentElement.querySelector('[data-bw-combo-error]');

    function fail(msg){
      if (errorEl){ errorEl.textContent = msg; errorEl.hidden = false; }
    }

    function refreshCart(){
      var action = (window.KROWN && KROWN.settings && KROWN.settings.cart_action) || 'popup';
      var url = action === 'popup'
        ? btn.getAttribute('data-product-url') + '?variant=' + btn.getAttribute('data-main-variant') + '&section_id=helper-cart-popup'
        : '?section_id=helper-cart';

      return fetch(url)
        .then(function(r){ return r.text(); })
        .then(function(html){
          var doc = new DOMParser().parseFromString(html, 'text/html');

          if (action === 'popup'){
            var target = document.querySelector('[data-js-site-cart-popup-content]');
            var src = doc.querySelector('.shopify-section');
            if (target && src) target.innerHTML = src.innerHTML;
          } else {
            var form = document.getElementById('AjaxCartForm');
            var newForm = doc.getElementById('AjaxCartForm');
            if (form && newForm){
              form.innerHTML = newForm.innerHTML;
              if (typeof form.ajaxifyCartItems === 'function') form.ajaxifyCartItems();
            }
            var sub = document.getElementById('AjaxCartSubtotal');
            var newSub = doc.getElementById('AjaxCartSubtotal');
            if (sub && newSub) sub.innerHTML = newSub.innerHTML;
            var rec = document.getElementById('cart-recommendations');
            if (rec && typeof rec.generateRecommendations === 'function') rec.generateRecommendations();
          }

          var count = doc.querySelector('[data-cart-count]');
          var total = doc.querySelector('[data-cart-total]');
          if (count) document.querySelectorAll('[data-header-cart-count]').forEach(function(e){ e.textContent = count.textContent; });
          if (total) document.querySelectorAll('[data-header-cart-total]').forEach(function(e){ e.textContent = total.textContent; });

          var sidebar = document.getElementById('site-cart-sidebar');
          if (sidebar && typeof sidebar.show === 'function' && !document.body.classList.contains('template-cart')) sidebar.show();

          if (window.KROWN && KROWN.functions && typeof KROWN.functions.eventDispatcher === 'function'){
            KROWN.functions.eventDispatcher('krown:cart:add', {productForm: null, variantId: btn.getAttribute('data-main-variant')});
          }
        })
        .catch(function(e){
          /* Hinzufügen hat geklappt, nur die Schublade nicht – dann wenigstens in den Warenkorb führen. */
          console.log('bw-combo refresh', e);
          window.location.href = '/cart';
        });
    }

    btn.addEventListener('click', function(){
      if (errorEl){ errorEl.hidden = true; }
      btn.classList.add('working');
      btn.disabled = true;

      var items;
      try { items = JSON.parse(btn.getAttribute('data-items')); }
      catch(e){ btn.classList.remove('working'); btn.disabled = false; return; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
        body: JSON.stringify({items: items})
      })
      .then(function(r){ return r.json().then(function(d){ return {ok: r.ok, data: d}; }); })
      .then(function(res){
        if (!res.ok){
          fail((res.data && (res.data.description || res.data.message)) || 'Das hat leider nicht geklappt.');
          return null;
        }
        return refreshCart();
      })
      .catch(function(e){
        console.log('bw-combo', e);
        fail('Das hat leider nicht geklappt. Bitte nochmals versuchen.');
      })
      .then(function(){
        btn.classList.remove('working');
        btn.disabled = false;
      });
    });
  });
})();
